module.exports = __webpack_public_path__ + "static/media/app_preview.1a8a7508.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/app_preview.png
// module id = 71
// module chunks = 4